var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-5 mt-5"},[_c('md-empty-state',{staticClass:"md-accent",attrs:{"md-rounded":"","md-icon":"warning","md-label":"Error","md-description":"Los datos no existen en la Base de Datos"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }